import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

import { ReactComponent as ThermostatSvg } from '../../assets/thermostatIcon.svg';

const Thermostat2Icon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <ThermostatSvg />
  </SvgIcon>
);

export default React.memo(Thermostat2Icon);
